<div class="main-container">
  <mat-card *ngIf="isLoading">
    <mat-card-content>
      <div style="padding: 50px">
        <mat-progress-spinner
          style="margin: auto"
          [diameter]="150"
          [strokeWidth]="10"
          mode="indeterminate"
        ></mat-progress-spinner>
      </div>
    </mat-card-content>
  </mat-card>
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined" *ngIf="!isLoading">
      <mat-card-title>Edit Contact Information</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">Error occurred</div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutGap="20px">
          <app-mat-simple-select
            fxFlex="50"
            formControlName="recordType"
            label="Contact Directory"
            name="recordType"
            [selectItems]="contactService.directoryEditList"
            [submitted]="submitted"
          >
          </app-mat-simple-select>

          <div fxLayout="column" fxLayoutGap="10px">
            <app-mat-slide-toggle-input
              *ngIf="form.getRawValue().recordType === 0"
              formControlName="syncPbx"
              name="syncPbx"
              color="primary"
              label="Sync with Phone System"
            >
            </app-mat-slide-toggle-input>
            <app-mat-slide-toggle-input
              *ngIf="form.getRawValue().syncPbx && form.getRawValue().recordType === 0"
              formControlName="blacklisted"
              name="blacklisted"
              color="warn"
              label="Blacklist on Phone System"
            >
            </app-mat-slide-toggle-input>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" *ngIf="canEditTags">
          <app-mat-tags-multiselect
            fxFlex
            [formControl]="getFormControl('tags')"
            label="Tags"
            name="tags"
            placeholder="Search Tags"
            [autoCompleteValues]="contactService.allTags"
            [suffixIcon]="canEditTags ? 'edit' : undefined"
            suffixTooltip="Manage Tags"
            (onSuffixClicked)="onManageTagsClick($event)"
            [submitted]="submitted"
          >
          </app-mat-tags-multiselect>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <app-mat-text-input
            fxFlex
            [formControl]="getFormControl('firstName')"
            label="First Name"
            name="firstName"
            [submitted]="submitted"
          ></app-mat-text-input>
          <app-mat-text-input
            fxFlex
            [formControl]="getFormControl('lastName')"
            label="Last Name"
            name="lastName"
            [submitted]="submitted"
          ></app-mat-text-input>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <app-mat-phone-number-input
            fxFlex
            [formControl]="getFormControl('phoneNumber')"
            label="Phone Number"
            name="phoneNumber"
            [submitted]="submitted"
          ></app-mat-phone-number-input>
          <app-mat-phone-number-input
            fxFlex
            [formControl]="getFormControl('mobileNumber')"
            label="Mobile Number"
            name="mobileNumber"
            [submitted]="submitted"
          ></app-mat-phone-number-input>
          <app-mat-phone-number-input
            fxFlex
            [formControl]="getFormControl('faxNumber')"
            label="Fax Number"
            name="faxNumber"
            [submitted]="submitted"
          ></app-mat-phone-number-input>
          <app-mat-text-input
            fxFlex
            [formControl]="getFormControl('speedDial')"
            label="Speed Dial"
            name="speedDial"
            [customErrors]="{
              pattern: 'Invalid speed dial. The speed dial must start with an optional \'*\' followed by digits.',
            }"
            [submitted]="submitted"
          ></app-mat-text-input>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutAlign="start center">
          <app-mat-simple-select
            fxFlex
            [formControl]="getFormControl('smsPhoneType')"
            label="Phone For Messaging Use"
            name="smsPhoneType"
            [selectItems]="contactService.smsPhoneTypeList"
            [submitted]="submitted"
          >
          </app-mat-simple-select>
          <app-mat-simple-select
            *ngIf="hasWhatsAppModule"
            fxFlex
            [formControl]="getFormControl('communicationType')"
            label="Preferred communication type"
            name="communicationType"
            [selectItems]="contactService.communicationTypes"
            [submitted]="submitted"
          >
          </app-mat-simple-select>

          <div *ngIf="hasWhatsAppModule">
            <div style="margin-top: 20px">
              <app-mat-checkbox-input
                [(ngModel)]="this.editModel.isOptedIn"
                [matTooltip]="this.editModel.isOptedIn ? optedInTooltip : notOptedInTooltip"
                [ngModelOptions]="{ standalone: true }"
                label="Is Opted In"
                [disabled]="true"
              ></app-mat-checkbox-input>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <app-mat-text-input
            fxFlex
            [formControl]="getFormControl('companyName')"
            label="Company Name"
            name="companyName"
            [submitted]="submitted"
          ></app-mat-text-input>
          <app-mat-text-input
            fxFlex
            [formControl]="getFormControl('position')"
            label="Position"
            name="position"
            [submitted]="submitted"
          ></app-mat-text-input>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <app-mat-text-input
            fxFlex
            [formControl]="getFormControl('email')"
            label="Email"
            name="email"
            [submitted]="submitted"
          ></app-mat-text-input>
        </div>

        <div formGroupName="customFields" *ngIf="form.get('customFields')">
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" *ngFor="let field of customFieldsDefinitions">
            <ng-container [ngSwitch]="field.fieldType">
              <!-- Text Input -->
              <app-mat-text-input
                *ngSwitchCase="'text'"
                fxFlex
                [formControlName]="field.fieldKey"
                [label]="field.fieldTitle"
                [name]="field.fieldKey"
                [submitted]="submitted"
              >
              </app-mat-text-input>

              <!-- Number Input -->
              <app-mat-number-input
                *ngSwitchCase="'number'"
                fxFlex
                [formControlName]="field.fieldKey"
                [label]="field.fieldTitle"
                [name]="field.fieldKey"
                [submitted]="submitted"
              >
              </app-mat-number-input>

              <!-- Boolean Input (Checkbox) -->
              <app-mat-checkbox-input
                *ngSwitchCase="'boolean'"
                fxFlex
                [formControlName]="field.fieldKey"
                [label]="field.fieldTitle"
                [name]="field.fieldKey"
                [submitted]="submitted"
              >
              </app-mat-checkbox-input>

              <!-- Date Input -->
              <app-mat-datetime-input
                *ngSwitchCase="'date'"
                fxFlex
                [formControlName]="field.fieldKey"
                [label]="field.fieldTitle"
                [name]="field.fieldKey"
                [submitted]="submitted"
              ></app-mat-datetime-input>

              <!-- String List Input -->
              <ng-container *ngSwitchCase="'list'">
                <ng-container *ngIf="field.fieldFormat === 'phoneNumber'; else defaultSelect">
                  <app-mat-multiselect
                    fxFlex
                    [displayPipe]="phoneNumberDisplayPipe"
                    [lookupDisplayPipe]="phoneNumberDisplayPipe"
                    validator="phoneNumber"
                    [formControlName]="field.fieldKey"
                    [label]="field.fieldTitle"
                    [name]="field.fieldKey"
                    [allowCustomValue]="false"
                    [submitted]="submitted"
                  ></app-mat-multiselect>
                </ng-container>

                <ng-template #defaultSelect>
                  <app-mat-multiselect
                    fxFlex
                    [formControlName]="field.fieldKey"
                    [label]="field.fieldTitle"
                    [name]="field.fieldKey"
                    [allowCustomValue]="true"
                    [submitted]="submitted"
                  ></app-mat-multiselect>
                </ng-template>
              </ng-container>

              <ng-template #defaultSelect>
                <app-mat-multiselect
                  fxFlex
                  [formControlName]="field.fieldKey"
                  [label]="field.fieldTitle"
                  [name]="field.fieldKey"
                  [allowCustomValue]="true"
                  [submitted]="submitted"
                ></app-mat-multiselect>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <button
    mat-raised-button
    type="button"
    color="primary"
    matTooltip="Save changes"
    [promiseBtn]="buttonSubmitPromise"
    *ngIf="canEdit()"
    (click)="onSubmit()"
  >
    Save
  </button>
  <button
    mat-raised-button
    color="warn"
    class="only-icon"
    type="button"
    matTooltip="Remove Contact"
    *ngIf="canDelete()"
    (click)="onDeleteClicked()"
  >
    <mat-icon>delete</mat-icon>
  </button>
</div>
